const inflate = require('pako/dist/pako_inflate.min.js').inflate;
import { Data } from 'pako';

export default class Zip {
    static unzip(zippedData: Data) {
        return JSON.parse(inflate(zippedData, { to: 'string' }));
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/utils/dataTransformation/Zip.ts